import React from "react";
import { Box as MuiBox, Grid as MuiGrid } from "@mui/material";

import { ITemplate } from "@framework/types";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { Typography } from "@dzambalaorg/ui-kit";

import { CraftTemplatePanel } from "./craft-template-panel";
import { TemplatePanel } from "./template-panel";

interface ITemplateContentProps {
  template: ITemplate;
}

export const TemplateContent = ({ template }: ITemplateContentProps) => {
  return (
    <MuiGrid container>
      <MuiGrid size={{ xs: 12, sm: 9 }}>
        <MuiBox component="img" src={template.imageUrl} alt="Cascadify template image" width={300} height={300} />
        <Typography variant="body2">
          <RichTextDisplay data={template.description} />
        </Typography>
      </MuiGrid>
      <MuiGrid size={{ xs: 12, sm: 3 }}>
        <>
          <TemplatePanel template={template} />
          <CraftTemplatePanel template={template} />
        </>
      </MuiGrid>
    </MuiGrid>
  );
};
